import React, { Component } from "react";
import { Link } from "react-router-dom";
import withRouter from "../withRouter.js";
import Credentials, { userid, currentTenant, einvoice, transactionFrom, prefix1, theme } from "../Common/Credentials";
import Header from "../Component/Header";
import Footer from "../Component/Footer";
import Menu from "../Component/Menu";
import {
  Autocomplete,
  FormControl,
  Grid,
  MenuItem,
  Select,
  Table,
  TableBody,
  TableCell,
  TableRow,
  TextField,
} from "@mui/material";
import IOSSwitch from "../CommonComponents/IOSSwitch";
import { FormControlLabel } from "@mui/material";
import SettingsServices from "./SettingsServices";
import PdfTempletes from "./PdfTempletes";
import Einvoicesettings from "./Einvoicesettings";
import plusfillIcon from "../images/Icons/plussolid.png"
import clearIcon from "../images/Icons/cross-mark.png"
import configicon from "../images/Icons/file.png"
import mailsettings from "../images/Icons/mailsetting.png"
import automailIcon from "../images/Icons/email.png"
import prototype from "../images/Icons/prototype.png"
import calendar from "../images/Icons/calendar.png"
import additonaloptions from "../images/Icons/choose.png"
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import MasterService from "../Masters/MasterService.js";
import Swal from "sweetalert2";
import MasterLedgerMapping from "./MasterLedgerMapping.jsx";
import Breadcrumb from "../NewUI/NewComponents/Breadcrumb.jsx";
import Layout from "../Component/Layout.jsx";
import LogoUpdate from "./LogoUpdate.jsx";
import { Calendar, ChevronDown, Database, Eye, FileCode, FileText, HelpCircle, LayoutTemplate, Link2, Mail, Minus, Plus, Settings2, ShoppingBag, Sliders, Tag } from "lucide-react";
import { OSSwitch } from "../NewUI/NewComponents/OSSwitch.jsx";
import moment from "moment";
import LogoUpload from "./LogoUpload.jsx";

const regexprefix = /^[a-zA-Z0-9-]*$/;
const regexslno = /^[0-9]*$/;

class Settings extends Component {
  constructor(props) {
    super(props);
    this.state = {
      soeditprice: false,
      salescal: false,
      dnreq: false,
      pouploadm: false,
      hover: false,
      additionlparams: false,
      salesautojre: false,
      purchaseautojre: false,
      disabletransactiondateselection: false,
      status: 0,
      customerprefix: "",
      customersno: "",
      customeredit: false,
      customereditstatus: "",
      supplierprefix: "",
      suppliersno: "",
      supplieredit: false,
      suppliereditstatus: "",
      agentprefix: "",
      agentno: "",
      agentedit: false,
      agenteditstatus: "",
      empprefix: "",
      empno: "",
      empedit: false,
      empditstatus: "",
      soprefix: "",
      sono: "",
      soedit: false,
      soeditstatus: "",
      poprefix: "",
      pono: "",
      poedit: false,
      poeditstatus: "",
      grnprefix: "",
      grnno: "",
      grnedit: false,
      grneditstatus: "",
      scnprefix: "",
      scnno: "",
      scnedit: false,
      scneditstatus: "",
      invoiceprefix: "",
      invoicesno: "",
      invoiceedit: false,
      invoiceeditstatus: "",
      dnprefix: "",
      dnno: "",
      dnedit: false,
      dneditstatus: "",
      qtprefix: "",
      qtno: "",
      qtedit: false,
      qteditstatus: "",
      assetprefix: "",
      assetno: "",
      assetedit: false,
      asseteditstatus: "",
      rentalprefix: "",
      rentalno: "",
      rentaledit: false,
      rentaleditstatus: "",
      soldprefix: "",
      soldno: "",
      soldedit: false,
      soldeditstatus: "",
      impprefix: "",
      impno: "",
      impedit: false,
      impeditstatus: "",
      estprefix: "",
      estno: "",
      estedit: false,
      esteditstatus: "",
      joprefix: "",
      jono: "",
      joedit: false,
      joeditstatus: "",
      storeprefix: "",
      storeno: "",
      storeedit: false,
      storeeditstatus: "",
      creditnoteprefix: "",
      creditnoteno: "",
      creditnoteedit: false,
      creditnoteeditstatus: "",
      mailbehavior: true,
      backdateinvoicestatus: false,
      salesproducts: true,
      salesservice: false,
      salespands: false,
      jretype: "",
      invuploadm: false,
      purchaseproducts: true,
      purchaseservice: false,
      purchasepands: false,
      salesroundoff: false,
      purchaseroundoff: false,

      templateid: 0,
      loader: false,
      buttondisable: false,
      licences: [],
      settings: {},
      transactionstartdate: new Date(),
      customprefixes: [],
      theme: theme
    };
  }

  updateThemeVariables = () => {

    document.documentElement.style.setProperty(
      "--UI-btn-primary-background",
      theme === "classic"
        ? "#4d4d4d" : "linear-gradient(to right, #2563eb, #4f46e5)"
    );
  };


  handleChange = () => {
    let data = {
      soeditprice: !this.state.soeditprice === true ? "YES" : "NO",
      tenantid: currentTenant,
    };
    SettingsServices.SoEditPrice(data).then(() => {
      this.setState({ soeditprice: !this.state.soeditprice });
    });

    // SettingsServices.UpdateSettings(data).then(
    //   (response) => {
    //     this.setState({
    //       additionlparams:response.data.additionalparamsforitem === "YES" ? true : false,
    //       salescal: response.data.salescalreq === "YES" ? true : false,
    //       dnreq: response.data.dnreq === "YES" ? true : false,
    //       soeditprice: response.data.soeditprice === "YES" ? true : false,
    //       salesproducts: response.data.salesproducts === "YES" ? true : false,
    //       salesservice: response.data.salesservice === "YES" ? true : false,
    //       salespands: response.data.salespands === "YES" ? true : false,
    //       purchaseproducts:response.data.purchaseproducts === "YES" ? true : false,
    //       purchaseservice: response.data.purchaseservice === "YES" ? true : false,
    //       purchasepands: response.data.purchasepands === "YES" ? true : false,
    //       pouploadm: response.data.pouploadm === "YES" ? true : false,
    //       invuploadm: response.data.invuploadm === "YES" ? true : false,
    //       mailbehavior: response.data.mailbehavior === "YES" ? true : false,
    //       salesautojre:response.data.salesautojre === "YES"?true : false,
    //       purchaseautojre:response.data.purchaseautojre === "YES"?true : false,
    //       salesroundoff:response.data.salesroundoff === "YES"?true:false,
    //       purchaseroundoff:response.data.purchaseroundoff==="YES"?true:false,
    //     });
    //   })
  };

  handleSalesCal = () => {
    let data = {
      salescal: !this.state.salescal === true ? "YES" : "NO",
      tenantid: currentTenant,
    };
    SettingsServices.SoSalesCalucation(data).then(() => {
      this.setState({ salescal: !this.state.salescal }, () => {
        if (this.state.salescal === true) {
          let data = {
            soeditprice: "YES",
            tenantid: currentTenant,
          };
          SettingsServices.SoEditPrice(data).then(() => {
            this.setState({ soeditprice: "YES" });
          });
        }
      });
    });
  };

  AllowExtraMarkup = (name) => {
    let data = {
      allowextramakup: !this.state.allowextramakup === true ? "YES" : "NO",
      tenantid: currentTenant,
    };
    // let data = this.state.settings 
    // console.log(name);
    // data[name] = data[name] === "YES"? "NO": "YES";
    // console.log(data);
    SettingsServices.UpdateSettings(data).then(() => {
      this.setState({ allowextramakup: !this.state.allowextramakup });
    });
  };


  SalesValueRoundoff = () => {
    let data = {
      salesroundoff: !this.state.salesroundoff === true ? "YES" : "NO",
      tenantid: currentTenant,
    };
    SettingsServices.SalesValueRoundoff(data).then(() => {
      this.setState({ salesroundoff: !this.state.salesroundoff });
    });
  };

  PurchaseValueRoundoff = () => {
    let data = {
      purchaseroundoff: !this.state.purchaseroundoff === true ? "YES" : "NO",
      tenantid: currentTenant,
    };
    SettingsServices.PurchaseValueRoundoff(data).then(() => {
      this.setState({ purchaseroundoff: !this.state.purchaseroundoff });
    });
  };

  // handleDnReq = () =>{
  //   let data = {
  //     dnreq: !this.state.dnreq === true ? "YES" : "NO",
  //     tenantid: currentTenant,
  //   };
  //   SettingsServices.Dnreq(data).then(() => {
  //     this.setState({
  //           dnreq: !this.state.dnreq,
  //           tenantid: currentTenant,
  //     });
  //   });
  // }

  handleAdditonalParams = () => {
    let data = {
      apitem: !this.state.additionlparams === true ? "YES" : "NO",
      tenantid: currentTenant,
    };
    SettingsServices.AdditionlParams(data).then(() => {
      this.setState({ additionlparams: !this.state.additionlparams });
    });
  };

  handleMailbehavior = () => {
    let data = {
      mailbehavior: !this.state.mailbehavior === true ? "YES" : "NO",
      tenantid: currentTenant,
    };

    SettingsServices.MailbehaviorService(data).then(() => {
      this.setState({ mailbehavior: !this.state.mailbehavior });
    });
  };

  handleJREEntryTypeChange = (e) => {
    if (e.target.value && e.target.value !== "" && e.target.value !== this.state.jretype) {
      let data = {
        jretype: e.target.value,
        tenantid: currentTenant,
      };
      SettingsServices.UpdateJREEntryType(data).then(() => {
        this.setState({ jretype: data.jretype });
      });
    }
  }

  handleSalesService = () => {
    let data = {
      salesservice: !this.state.salesservice === true ? "YES" : "NO",
      tenantid: currentTenant,
    };
    SettingsServices.SalesService(data).then(() => {
      this.setState({ salesservice: !this.state.salesservice });
    });
  };

  handleChangeSalesAutoJRE = () => {
    let data = {
      salesservice: !this.state.salesautojre === true ? "YES" : "NO",
      tenantid: currentTenant,
    };
    SettingsServices.SalesAutoJRE(data).then(() => {
      this.setState({ salesautojre: !this.state.salesautojre });
    });
  }

  handleChangePurchaseAutoJRE = () => {
    let data = {
      salesservice: !this.state.purchaseautojre === true ? "YES" : "NO",
      tenantid: currentTenant,
    };
    SettingsServices.PurchaseAutoJRE(data).then(() => {
      this.setState({ purchaseautojre: !this.state.purchaseautojre });
    });
  }

  handlepouploadm = () => {
    let data = {
      pouploadm: !this.state.pouploadm === true ? "YES" : "NO",
      tenantid: currentTenant,
    };
    SettingsServices.POupload(data).then(() => {
      this.setState({ pouploadm: !this.state.pouploadm });
    });
  };
  handlebackdateinvoice = () => {
    let data = {
      backdateinvoicestatus: !this.state.backdateinvoicestatus === true ? "YES" : "NO",
      tenantid: currentTenant,
    };
    SettingsServices.BackDateInvoiceStatus(data).then(() => {
      this.setState({ backdateinvoicestatus: !this.state.backdateinvoicestatus });
    });
  }

  handleSalesPandS = () => {
    let data = {
      salespands: !this.state.salespands === true ? "YES" : "NO",
      tenantid: currentTenant,
    };
    SettingsServices.SalesPandS(data).then(() => {
      this.setState({ salespands: !this.state.salespands });
    });
  };

  handleLicense = () => {
    this.setState({
      licences: [
        ...this.state.licences,
        { name: "", number: "", edit: true, tenantid: currentTenant },
      ],
    });
  };

  onlicenceNameChange = (val, idx) => {
    let data = this.state.licences;
    data.find((e, i) => i === idx).name = val;
    this.setState({ licences: data });
  };

  onlicenceChange = (val, idx) => {
    let data = this.state.licences;
    data.find((e, i) => i === idx).number = val;
    this.setState({ licences: data });
  };

  updateLicence = (val, idx) => {
    this.setState({ buttondisable: true });
    SettingsServices.Addlicencesoftenant(val)
      .then((response) => {
        // this.GetLicences()
        let data = this.state.licences.filter((e, i) => i !== idx);
        this.setState({
          licences: [...data, response.data],
          buttondisable: false,
        });
      })
      .catch(() => this.setState({ buttondisable: false }));
  };

  Deletelicence = (val, idx) => {
    if (val.id === null || val.id === undefined || val.id === "") {
      let data = this.state.licences.filter((e, i) => i !== idx);
      this.setState({ licences: data });
    } else {
      SettingsServices.Deletelicenseoftenant(val.id).then(() => {
        let data = this.state.licences.filter((e, i) => i !== idx);
        this.setState({ licences: data });
      });
    }
  };

  handlePurchaseService = () => {
    let data = {
      purchaseservice: !this.state.purchaseservice === true ? "YES" : "NO",
      tenantid: currentTenant,
    };
    SettingsServices.PurchaseService(data).then(() => {
      this.setState({ purchaseservice: !this.state.purchaseservice });
    });
  };

  handlePurchasePandS = () => {
    let data = {
      purchasepands: !this.state.purchasepands === true ? "YES" : "NO",
      tenantid: currentTenant,
    };
    SettingsServices.PurchasePandS(data).then(() => {
      this.setState({ purchasepands: !this.state.purchasepands });
    });
  };

  handleinvuploadm = () => {
    let data = {
      invuploadm: !this.state.invuploadm === true ? "YES" : "NO",
      tenantid: currentTenant,
    };
    SettingsServices.InvUpload(data).then(() => {
      this.setState({ invuploadm: !this.state.invuploadm });
    });
  };

  handleCustomerEdit = () => {
    this.setState({ customeredit: true });
  };
  handleSupplierEdit = () => {
    this.setState({ supplieredit: true });
  };
  handleEmployeeEdit = () => {
    this.setState({ empedit: true });
  };
  handleSoEdit = () => {
    this.setState({ soedit: true });
  };
  handlePoEdit = () => {
    this.setState({ poedit: true });
  };
  handleGrnEdit = () => {
    this.setState({ grnedit: true });
  };
  handleSCNedit = () => {
    this.setState({ scnedit: true });
  };
  handleInvoiceEdit = () => {
    this.setState({ invoiceedit: true });
  };
  handleDNEdit = () => {
    this.setState({ dnedit: true });
  };
  handleQtEdit = () => {
    this.setState({ qtedit: true });
  };
  handleAssetEdit = () => {
    this.setState({ assetedit: true });
  };
  handleRentalEdit = () => {
    this.setState({ rentaledit: true });
  };
  handleSoldEdit = () => {
    this.setState({ soldedit: true });
  };
  handleImpEdit = () => {
    this.setState({ impedit: true });
  };
  handleEstEdit = () => {
    this.setState({ estedit: true });
  };
  handleJoEdit = () => {
    this.setState({ joedit: true });
  };
  handleStoreEdit = () => {
    this.setState({ storeedit: true });
  };

  handlecreditnoteEdit = () => {
    this.setState({ creditnoteedit: true });
  };

  updateCustprefix = () => {
    let data = {
      custprefix: this.state.customerprefix,
      custserialnum: this.state.customersno,
      tenantid: currentTenant,
    };
    SettingsServices.updateCustprefix(data).then(() => {
      this.setState({ customeredit: false });
    });
  };

  updateSupplierPrefix = () => {
    let data = {
      supprefix: this.state.supplierprefix,
      supserialnum: this.state.suppliersno,
      tenantid: currentTenant,
    };
    SettingsServices.updateSupprefix(data).then(() => {
      this.setState({ supplieredit: false });
    });
  };

  updateEmployeePrefix = () => {
    let data = {
      custprefix: this.state.empprefix,
      custserialnum: this.state.empno,
      tenantid: currentTenant,
    };
    SettingsServices.updateEmployeeprefix(data).then(() => {
      this.setState({ empedit: false });
    });
  };

  updateSoprefix = () => {
    let data = {
      soprefix: this.state.soprefix,
      soserialnum: this.state.sono,
      tenantid: currentTenant,
    };
    SettingsServices.updateSoprefix(data).then(() => {
      this.setState({ soedit: false });
    });
  };

  updatePoprefix = () => {
    let data = {
      poprefix: this.state.poprefix,
      poserialnum: this.state.pono,
      tenantid: currentTenant,
    };
    SettingsServices.updatePoprefix(data).then(() => {
      this.setState({ poedit: false });
    });
  };

  updateGrnprefix = () => {
    let data = {
      grnprefix: this.state.grnprefix,
      grnserialnum: this.state.grnno,
      tenantid: currentTenant,
    };
    SettingsServices.updateGrnprefix(data).then(() => {
      this.setState({ grnedit: false });
    });
  };

  updateSCNprefix = () => {
    let data = {
      scnprefix: this.state.scnprefix,
      scnserialnum: this.state.scnno,
      tenantid: currentTenant,
    };
    SettingsServices.updateSCNprefix(data).then(() => {
      this.setState({ scnedit: false });
    });
  };

  updateInvprefix = () => {
    let data = {
      invprefix: this.state.invoiceprefix,
      invserialnum: this.state.invoicesno,
      tenantid: currentTenant,
    };
    SettingsServices.updateInvprefix(data).then(() => {
      this.setState({ invoiceedit: false });
    });
  };

  updateDnprefix = () => {
    let data = {
      dnprefix: this.state.dnprefix,
      dnserialnum: this.state.dnno,
      tenantid: currentTenant,
    };
    SettingsServices.updateDnprefix(data).then(() => {
      this.setState({ dnedit: false });
    });
  };

  updateQtprefix = () => {
    let data = {
      quotationprefix: this.state.qtprefix,
      quotationserialnum: this.state.qtno,
      tenantid: currentTenant,
    };
    SettingsServices.updateQtprefix(data).then(() => {
      this.setState({ qtedit: false });
    });
  };

  updateAssetprefix = () => {
    let data = {
      assetprefix: this.state.assetprefix,
      serialnum: this.state.assetno,
      tenantid: currentTenant,
    };
    SettingsServices.updateAssetprefix(data).then(() => {
      this.setState({ assetedit: false });
    });
  };
  updateRentalprefix = () => {
    let data = {
      prefix: this.state.rentalprefix,
      serialnum: this.state.rentalno,
      tenantid: currentTenant,
    };
    SettingsServices.updateRentalprefix(data).then(() => {
      this.setState({ rentaledit: false });
    });
  };

  updateSoldprefix = () => {
    let data = {
      prefix: this.state.soldprefix,
      serialnum: this.state.soldno,
      tenantid: currentTenant,
    };
    SettingsServices.updateSoldprefix(data).then(() => {
      this.setState({ soldedit: false });
    });
  };

  updateImpprefix = () => {
    let data = {
      prefix: this.state.impprefix,
      serialnum: this.state.impno,
      tenantid: currentTenant,
    };
    SettingsServices.updateImpprefix(data).then(() => {
      this.setState({ impedit: false });
    });
  };

  updateEstprefix = () => {
    let data = {
      prefix: this.state.estprefix,
      serialnum: this.state.estno,
      tenantid: currentTenant,
    };
    SettingsServices.updateEstprefix(data).then(() => {
      this.setState({ estedit: false });
    });
  };

  updateJoprefix = () => {
    let data = {
      prefix: this.state.joprefix,
      serialnum: this.state.jono,
      tenantid: currentTenant,
    };
    SettingsServices.updateJoprefix(data).then(() => {
      this.setState({ joedit: false });
    });
  };

  updateStoreprefix = () => {
    let data = {
      prefix: this.state.storeprefix,
      serialnum: parseInt(this.state.storeno),
      tenantid: currentTenant,
    };
    SettingsServices.updateStoreprefix(data).then(() => {
      this.setState({ storeedit: false });
    });
  };

  updatecreditnoteprefix = () => {
    let data = {
      prefix: this.state.creditnoteprefix,
      serialnum: this.state.creditnoteno,
      tenantid: currentTenant,
    };
    SettingsServices.updateCreditnoteprefix(data).then(() => {
      this.setState({ creditnoteedit: false });
    });
  };

  // handleFinalSubmit=()=>{

  // }

  updatecustomprefix = (e, i) => {
    SettingsServices.addprefix(e).then(() => {
      let updata = this.state.customprefixes
      updata[i] = { ...e, edit: false }
      this.setState({ customprefixes: updata })
    })
  }


  handleTransactionStartDateChange = (date) => {
    this.setState({ transactionstartdate: date })
  }
  handleConfirmTransactionStartDate = () => {
    let data = {
      date: this.state.transactionstartdate,
      tenantid: currentTenant
    }

    Swal.fire({
      title: "Set transaction start date",
      text: "Are you sure?",
      icon: "question",
      showCancelButton: true,
      confirmButtonText: "Yes",
      confirmButtonColor: "#152f5f",
      cancelButtonText: "No",
      reverseButtons: true,
    }).then((result) => {
      if (result.value) {
        MasterService.UpdateransactionStartDate(data).then(() => {
          Credentials.setTransactionFrom(this.state.transactionstartdate)
          this.setState({ disabletransactiondateselection: true })
          Swal.fire({
            title: "Transaction start date added successfully!",
            text: "now you can start your transactions.",
            icon: "success",
            confirmButtonText: "Ok",
            confirmButtonColor: "#152f5f",
          })
        })
      }
    })
  }

  GetAllPrefixes = () => {
    if (this.state.status === 3) {
      this.setState({ status: 0 })
    } else {
      this.setState({ status: 3 });
      SettingsServices.GetAllPrefixes(currentTenant).then((resp) => {
        this.setState({
          customerprefix: resp.data.custprefix?.custprefix,
          customersno: resp.data.custprefix?.custserialnum,
          customereditstatus: resp.data.custprefix?.activestatus,

          supplierprefix: resp.data.supprefix?.supprefix,
          suppliersno: resp.data.supprefix?.supserialnum,
          suppliereditstatus: resp.data.supprefix?.activestatus,

          // agentprefix:resp.data.agentprefix.prefix,
          // agentno:resp.data.agentprefix.serialnum,
          // agenteditstatus: resp.data.agentprefix.activestatus,

          soprefix: resp.data.soprefix?.soprefix,
          sono: resp.data.soprefix?.soserialnum,
          soeditstatus: resp.data.soprefix?.activestatus,

          poprefix: resp.data.poprefix?.poprefix,
          pono: resp.data.poprefix?.poserialnum,
          poeditstatus: resp.data.poprefix?.activestatus,

          grnprefix: resp.data.grnprefix?.grnprefix,
          grnno: resp.data.grnprefix?.grnserialnum,
          grneditstatus: resp.data.grnprefix?.activestatus,

          scnprefix: resp.data.scnprefix?.scnprefix,
          scnno: resp.data.scnprefix?.scnserialnum,
          scneditstatus: resp.data.scnprefix?.activestatus,

          invoiceprefix: resp.data.invprefix?.invprefix,
          invoicesno: resp.data.invprefix?.invserialnum,
          invoiceeditstatus: resp.data.invprefix?.activestatus,

          dnprefix: resp.data.dnprefix?.dnprefix,
          dnno: resp.data.dnprefix?.dnserialnum,
          dneditstatus: resp.data.dnprefix?.activestatus,

          qtprefix: resp.data.qtprefix?.quotationprefix,
          qtno: resp.data.qtprefix?.quotationserialnum,
          qteditstatus: resp.data.qtprefix?.activestatus,

          assetprefix: resp.data.assetprefix?.assetprefix,
          assetno: resp.data.assetprefix?.serialnum,
          asseteditstatus: resp.data.assetprefix?.activestatus,

          rentalprefix: resp.data.rentalprefix?.prefix,
          rentalno: resp.data.rentalprefix?.serialnum,
          rentaleditstatus: resp.data.rentalprefix?.activestatus,

          soldprefix: resp.data.soldprefix?.prefix,
          soldno: resp.data.soldprefix?.serialnum,
          soldeditstatus: resp.data.soldprefix?.activestatus,

          impprefix: resp.data.impprefix?.prefix,
          impno: resp.data.impprefix?.serialnum,
          impeditstatus: resp.data.impprefix?.activestatus,

          estprefix: resp.data.estprefix?.prefix,
          estno: resp.data.estprefix?.serialnum,
          esteditstatus: resp.data.estprefix?.activestatus,

          joprefix: resp.data.joprefix?.prefix,
          jono: resp.data.joprefix?.serialnum,
          joeditstatus: resp.data.joprefix?.activestatus,

          storeprefix: resp.data.storeprefix?.prefix,
          storeno: resp.data.storeprefix?.serialnum,
          storeeditstatus: resp.data.storeprefix?.activestatus,

          empprefix: resp.data.employeeprefix?.custprefix,
          empno: resp.data.employeeprefix?.custserialnum,
          empeditstatus: resp.data.employeeprefix?.activestatus,

          creditnoteprefix: resp.data.creditnoteprefix?.prefix,
          creditnoteno: resp.data.creditnoteprefix?.serialnum,
          creditnoteeditstatus: resp.data.creditnoteprefix?.activestatus,
        });
      });

      SettingsServices.getallprefixesoftenant(currentTenant).then((resp) => {
        let resdata = resp.data.filter(e => e.type === "DirectCNDN")
        resdata = resdata.map(e => {
          return { ...e, edit: false };
        })
        this.setState({ customprefixes: resdata })

      })
    }
  };

  componentDidMount() {
    if (userid === undefined) {
      window.confirm("Your Session is Lost: Please login Back to resume");
      this.props.navigate(`/`);
    }
    this.updateThemeVariables();
    Credentials.setSelectedMenu("settings")
    SettingsServices.GetSettings(currentTenant).then((response) => {
      this.setState({
        settings: response.data,
        additionlparams: response.data.additionalparamsforitem === "YES" ? true : false,
        salescal: response.data.salescalreq === "YES" ? true : false,
        dnreq: response.data.dnreq === "YES" ? true : false,
        soeditprice: response.data.soeditprice === "YES" ? true : false,
        salesproducts: response.data.salesproducts === "YES" ? true : false,
        salesservice: response.data.salesservice === "YES" ? true : false,
        salespands: response.data.salespands === "YES" ? true : false,
        purchaseproducts: response.data.purchaseproducts === "YES" ? true : false,
        purchaseservice: response.data.purchaseservice === "YES" ? true : false,
        purchasepands: response.data.purchasepands === "YES" ? true : false,
        pouploadm: response.data.pouploadm === "YES" ? true : false,
        invuploadm: response.data.invuploadm === "YES" ? true : false,
        mailbehavior: response.data.mailbehavior === "YES" ? true : false,
        salesautojre: response.data.salesautojre === "YES" ? true : false,
        purchaseautojre: response.data.purchaseautojre === "YES" ? true : false,
        salesroundoff: response.data.salesroundoff === "YES" ? true : false,
        purchaseroundoff: response.data.purchaseroundoff === "YES" ? true : false,
        backdateinvoicestatus: response.data.backdateinvoicestatus === "YES" ? true : false,
        jretype: response.data.jretype
      });
    });


    this.GetLicences();
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevState.theme !== this.state.theme) {
      this.updateThemeVariables();
    }
  }



  GetLicences = () => {
    SettingsServices.Getlicencesoftenant(currentTenant).then((response) =>
      this.setState({ licences: response.data })
    );
  };

  render() {
    return (
      <div>
        <Layout menu={"settings"}>
          <div className="UI-container">
            {/* Upper Hero Grid */}
            <div
              id="hero-welcome-banner"
              className="tw-grid tw-grid-cols-1 md:tw-grid-cols-3 tw-items-center tw-bg-white tw-rounded-3xl tw-px-8 tw-py-2 tw-border tw-border-slate-200/80 tw-shadow-[0_12px_40px_rgba(0,0,0,0.02)] tw-mb-4 tw-relative tw-overflow-hidden"
            >
              {/* Background Blur Shapes */}
              <div className="tw-absolute tw-top-0 tw-right-0 tw-w-96 tw-h-96 tw-bg-blue-50/40 tw-rounded-full tw-blur-3xl -tw-z-10 tw-translate-x-12 -tw-translate-y-12"></div>

              <div className="tw-absolute tw-bottom-0 tw-left-0 tw-w-64 tw-h-64 tw-bg-indigo-50/30 tw-rounded-full tw-blur-3xl -tw-z-10 -tw-translate-x-12 tw-translate-y-12"></div>

              {/* Left Content */}
              <div className="md:tw-col-span-2 tw-text-left tw-space-y-2">
                <Breadcrumb breadcrumbs={[{ name: "Home", path: "/index" }, { name: "Settings", path: null }]} />
                <h1 className="tw-text-4xl tw-font-extrabold tw-tracking-tight tw-text-slate-900 tw-pt-1">
                  Settings
                </h1>

                <p className="tw-text-slate-500 tw-font-medium tw-text-[10px] md:tw-text-xs tw-max-w-lg">
                  Standardize default reporting currencies, program secure corporate SMTP email credentials protocols, and toggle physical Multi-Factor security clearances.
                </p>
              </div>

              {/* 3D SVG Security Badging Illustration */}
              <div className="tw-flex tw-justify-center md:tw-justify-end mt-0 tw-relative tw-group">
                {/* <div className="tw-w-40 tw-h-40 tw-relative tw-flex tw-items-center tw-justify-center tw-animate-bounce tw-duration-1000 tw-ease-in-out" style={{ animationDuration: '4.5s' }}> */}
                <div className="tw-w-20 tw-h-20 tw-relative tw-flex tw-items-center tw-justify-center">

                  <div className="tw-absolute tw-bottom-4 tw-w-20 tw-h-3 tw-bg-slate-300/30 tw-rounded-full tw-blur-md"></div>

                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 512 512"
                    // width={size}
                    // height={size}
                    className="tw-w-20 tw-h-20 tw-select-none tw-pointer-events-none"
                    fill="none"
                  >
                    <circle fill="#BDFBFD" cx="256" cy="256" r="256" />

                    <path
                      fill="#00E4ED"
                      d="M275.092 511.291c126.162-9.302 226.897-110.037 236.199-236.199L379.197 142.998l-3.751 32.99-83.18-83.18-116.14 101.707L96.539 205.81l110.645 110.645-74.38 52.546 142.288 142.29z"
                    />

                    <path
                      fill="#324A5E"
                      d="M382.928 256c0-10.128-1.221-19.966-3.462-29.408l35.995-20.782-36.264-62.812-36.021 20.795c-14.252-13.478-31.613-23.69-50.912-29.434V92.808h-72.53v41.551c-19.297 5.744-36.659 15.956-50.91 29.434l-36.019-20.795L96.539 205.81l35.995 20.782c-2.241 9.442-3.462 19.28-3.462 29.408 0 10.128 1.221 19.966 3.462 29.408L96.539 306.19l36.266 62.814 36.019-20.795c14.252 13.479 31.613 23.69 50.91 29.434v41.551h72.53v-41.551c19.297-5.744 36.659-15.956 50.912-29.434l36.021 20.795 36.264-62.814-35.997-20.782c2.241-9.442 3.462-19.28 3.462-29.408zM256 310.398c-30.043 0-54.398-24.355-54.398-54.398S225.957 201.602 256 201.602 310.398 225.957 310.398 256 286.043 310.398 256 310.398z"
                    />

                    <path
                      fill="#2B3B4E"
                      d="M382.928 256c0-10.128-1.221-19.966-3.462-29.408l35.995-20.782-36.264-62.812-36.021 20.795c-14.252-13.478-31.613-23.69-50.91-29.434V92.806h-36.84v108.809c.191-.002.381-.014.574-.014 30.043 0 54.398 24.354 54.398 54.398S286.042 310.398 256 310.398c-.193 0-.383-.012-.574-.014v108.809h36.84v-41.551c19.297-5.744 36.659-15.955 50.91-29.434l36.021 20.795 36.264-62.814-35.995-20.782c2.241-9.442 3.462-19.28 3.462-29.408z"
                    />

                    <path
                      fill="#FFD15D"
                      d="M256 181.682c-41.044 0-74.318 33.273-74.318 74.318 0 41.044 33.273 74.318 74.318 74.318 41.044 0 74.318-33.273 74.318-74.318S297.044 181.682 256 181.682zm0 138.858c-35.643 0-64.54-28.894-64.54-64.54s28.896-64.54 64.54-64.54 64.54 28.894 64.54 64.54-28.897 64.54-64.54 64.54z"
                    />

                    <path
                      fill="#F4A200"
                      d="M256 181.682c-.193 0-.381.014-.574.014v9.778c.191-.002.381-.014.574-.014 35.643 0 64.54 28.894 64.54 64.54s-28.894 64.54-64.54 64.54c-.193 0-.383-.012-.574-.014v9.778c.193 0 .381.014.574.014 41.044 0 74.318-33.273 74.318-74.318S297.044 181.682 256 181.682z"
                    />
                  </svg>

                </div>
              </div>
            </div>
            <div className="form row tw-mx-0 ">

              <div className="col-md-5 col-sm-12 ">
                {/* Core Structured settings box */}
                <div className="tw-bg-white tw-border tw-border-slate-200/60 tw-rounded-3xl tw-p-6 tw-shadow-sm tw-divide-y tw-divide-slate-100">

                  {/* Setting 0: ApplicationTheme */}
                  <div id="setting-data-visibility" className="tw-py-5 tw-flex tw-flex-col md:tw-flex-row tw-items-start md:tw-items-center tw-justify-between tw-gap-4">
                    <div className="tw-flex tw-items-center tw-gap-3.5 tw-text-left">
                      <div className={`tw-w-10 tw-h-10 tw-rounded-xl tw-flex tw-items-center tw-justify-center tw-shrink-0 ${theme === 'classic' ? 'tw-bg-[#f8f0e7] tw-text-[#4d4d4d]' : 'tw-bg-indigo-50 tw-text-indigo-600'}`}>
                        <Eye size={18} />
                      </div>
                      <div>
                        <span className="tw-text-sm tw-font-extrabold tw-text-slate-800 tw-block">Application Theme</span>
                        <span className="tw-text-[11px] tw-text-slate-400 tw-font-medium tw-block">Control the visual theme of the application</span>
                      </div>
                    </div>

                    <div className="tw-relative">
                      <select
                        id="select-data-visibility"
                        value={theme}
                        onChange={(e) => { Credentials.setTheme(e.target.value); this.setState({ theme: e.target.value }); this.props.navigate("/settings") }}
                        className="tw-appearance-none tw-bg-slate-50 tw-border tw-border-slate-200 tw-hover:border-slate-300 tw-rounded-xl tw-pl-3.5 tw-pr-8 tw-py-2 tw-text-xs tw-font-bold tw-text-slate-705 tw-outline-none tw-cursor-pointer tw-focus:ring-2 tw-focus:ring-indigo-500/10 tw-focus:border-indigo-500 tw-transition-all"
                      >
                        <option value="modern">Modern</option>
                        <option value="classic">Classic</option>
                      </select>
                      <ChevronDown size={13} className="tw-absolute tw-right-2.5 tw-top-1/2 -tw-translate-y-1/2 tw-text-slate-450 tw-pointer-events-none" />
                    </div>
                  </div>

                  {/* Setting 1: Transaction Start Date */}
                  <div
                    id="setting-transaction-date"
                    className="tw-py-5 first:tw-pt-0 tw-flex tw-flex-col md:tw-flex-row tw-items-start md:tw-items-center tw-justify-between tw-gap-4 tw-transition-colors"
                  >
                    <div className="tw-flex tw-items-center tw-gap-3.5 tw-text-left">
                      <div className={`tw-w-10 tw-h-10 tw-rounded-xl ${theme === 'classic' ? 'tw-bg-[#f8f0e7] tw-text-[#4d4d4d]' : 'tw-bg-indigo-50 tw-text-indigo-600'} tw-flex tw-items-center tw-justify-center tw-shrink-0`}>
                        <Calendar size={18} />
                      </div>
                      <div>
                        <span className="tw-text-sm tw-font-extrabold tw-text-slate-800 tw-block">
                          Transaction Start Date
                        </span>
                        <span className="tw-text-[11px] tw-text-slate-400 tw-font-medium tw-block">
                          Set the start date for transactions
                        </span>
                      </div>
                    </div>

                    <div className="tw-flex tw-items-center tw-gap-2 tw-w-full md:tw-w-auto tw-justify-end">
                      <div className="tw-relative">
                        <input
                          type="date"
                          value={moment(transactionFrom === null ? this.state.transactionstartdate : transactionFrom).format("YYYY-MM-DD")}
                          onChange={this.handleTransactionStartDateChange}
                          disabled={transactionFrom !== null || this.state.disabletransactiondateselection}
                          className="tw-appearance-none tw-bg-slate-50 tw-border tw-border-slate-200 hover:tw-border-slate-300 tw-rounded-xl tw-px-3.5 tw-py-2 tw-text-xs tw-font-bold tw-text-slate-700 tw-outline-none tw-cursor-pointer focus:tw-ring-2 focus:tw-ring-indigo-500/10 focus:tw-border-indigo-500 tw-transition-all tw-text-right"
                        />

                      </div>
                    </div>
                  </div>

                  {/* Setting 2: Additional Parameters for Item Creation */}
                  <div id="setting-additional-parameters" className="tw-py-5 tw-flex tw-flex-col md:tw-flex-row tw-items-start md:tw-items-center tw-justify-between tw-gap-4">
                    <div className="tw-flex tw-items-center tw-gap-3.5 tw-text-left">
                      <div className={`tw-w-10 tw-h-10 tw-rounded-xl ${theme === 'classic' ? 'tw-bg-[#f8f0e7] tw-text-[#4d4d4d]' : ' tw-bg-emerald-50 tw-text-emerald-600'} tw-flex tw-items-center tw-justify-center tw-shrink-0`}>
                        <Sliders size={18} />
                      </div>
                      <div>
                        <span className="tw-text-sm tw-font-extrabold tw-text-slate-800 tw-block">Additional Parameters for Item Creation</span>
                        <span className="tw-text-[11px] tw-text-slate-400 tw-font-medium tw-block">Enable additional fields and parameters</span>
                      </div>
                    </div>

                    <div className="tw-flex tw-items-center">
                      <OSSwitch checked={this.state.additionlparams} onChange={this.handleAdditonalParams} />
                    </div>
                  </div>

                  {/* Setting 3: Mail behavior Automatic */}
                  <div id="setting-mail-behavior" className="tw-py-5 tw-flex tw-flex-col md:tw-flex-row tw-items-start md:tw-items-center tw-justify-between tw-gap-4">
                    <div className="tw-flex tw-items-center tw-gap-3.5 tw-text-left">
                      <div className={`tw-w-10 tw-h-10 tw-rounded-xl ${theme === 'classic' ? 'tw-bg-[#f8f0e7] tw-text-[#4d4d4d]' : 'tw-bg-sky-50 tw-text-sky-600'} tw-flex tw-items-center tw-justify-center tw-shrink-0`}>
                        <Mail size={18} />
                      </div>
                      <div>
                        <span className="tw-text-sm tw-font-extrabold tw-text-slate-800 tw-block">Mail behavior Automatic</span>
                        <span className="tw-text-[11px] tw-text-slate-400 tw-font-medium tw-block">Automatically handle email behaviors</span>
                      </div>
                    </div>

                    <div className="tw-flex tw-items-center">
                      <OSSwitch checked={this.state.mailbehavior} onChange={this.handleMailbehavior} />
                    </div>
                  </div>
                  {/* Setting 4: Data Visibility */}
                  <div id="setting-data-visibility" className="tw-py-5 tw-flex tw-flex-col md:tw-flex-row tw-items-start md:tw-items-center tw-justify-between tw-gap-4">
                    <div className="tw-flex tw-items-center tw-gap-3.5 tw-text-left">
                      <div className={`tw-w-10 tw-h-10 tw-rounded-xl ${theme === 'classic' ? 'tw-bg-[#f8f0e7] tw-text-[#4d4d4d]' : 'tw-bg-amber-50 tw-text-amber-600'} tw-flex tw-items-center tw-justify-center tw-shrink-0`}>
                        <Eye size={18} />
                      </div>
                      <div>
                        <span className="tw-text-sm tw-font-extrabold tw-text-slate-800 tw-block">Data Visibility</span>
                        <span className="tw-text-[11px] tw-text-slate-400 tw-font-medium tw-block">Control data visibility settings</span>
                      </div>
                    </div>

                    <div className="tw-relative">
                      <select
                        id="select-data-visibility"
                        value={this.state.jretype}
                        onChange={this.handleJREEntryTypeChange}
                        className="tw-appearance-none tw-bg-slate-50 tw-border tw-border-slate-200 tw-hover:border-slate-300 tw-rounded-xl tw-pl-3.5 tw-pr-8 tw-py-2 tw-text-xs tw-font-bold tw-text-slate-705 tw-outline-none tw-cursor-pointer tw-focus:ring-2 tw-focus:ring-indigo-500/10 tw-focus:border-indigo-500 tw-transition-all"
                      >
                        <option value="All">All</option>
                        <option value="Branch">Organization Unit/Branch</option>
                        <option value="Department">Department</option>
                      </select>
                      <ChevronDown size={13} className="tw-absolute tw-right-2.5 tw-top-1/2 -tw-translate-y-1/2 tw-text-slate-450 tw-pointer-events-none" />
                    </div>
                  </div>

                  {/* Setting 5: Master Ledger Settings */}
                  <div id="setting-master-ledger" className="tw-py-4">
                    <div className="tw-flex tw-items-center tw-justify-between tw-gap-4">
                      <div className="tw-flex tw-items-center tw-gap-3.5 tw-text-left">
                        <div className={`tw-w-10 tw-h-10 tw-rounded-xl ${theme === 'classic' ? 'tw-bg-[#f8f0e7] tw-text-[#4d4d4d]' : 'tw-bg-indigo-50 tw-text-indigo-600'} tw-flex tw-items-center tw-justify-center tw-shrink-0`}>
                          <FileText size={18} />
                        </div>
                        <div>
                          <span className="tw-text-sm tw-font-extrabold tw-text-slate-800 tw-block">Master Ledger Settings</span>
                          <span className="tw-text-[11px] tw-text-slate-400 tw-font-medium tw-block">Configure master ledger preferences</span>
                        </div>
                      </div>
                      <button
                        type="button"
                        id="accordion-toggle-master-ledger"
                        onClick={() => this.state.status === 8 ? this.setState({ status: 0 }) : this.setState({ status: 8 })}
                        className={`tw-p-1.5 tw-rounded-lg border border-slate-200 text-slate-450 hover:text-slate-800 hover:bg-slate-50 transition-all cursor-pointer ${this.state.status === 8 ? theme === "classic" ? 'tw-bg-[#4d4d4d] tw-text-white' : 'tw-bg-gradient-to-r tw-from-blue-600 tw-to-indigo-600 tw-text-white' : ''}`}
                      >
                        {this.state.status === 8 ? <Minus size={16} /> : <Plus size={16} />}
                      </button>
                    </div>
                  </div>
                  {/* Setting 6: Sales Settings */}
                  <div id="setting-sales-settings" className="tw-py-4">
                    <div className="tw-flex tw-items-center tw-justify-between tw-gap-4">
                      <div className="tw-flex tw-items-center tw-gap-3.5 tw-text-left">
                        <div className={`tw-w-10 tw-h-10 tw-rounded-xl ${theme === 'classic' ? 'tw-bg-[#f8f0e7] tw-text-[#4d4d4d]' : 'tw-bg-teal-50 tw-text-teal-600'} tw-flex tw-items-center tw-justify-center tw-shrink-0`}>
                          <Tag size={18} />
                        </div>
                        <div>
                          <span className="tw-text-sm tw-font-extrabold tw-text-slate-800 tw-block">Sales Settings</span>
                          <span className="tw-text-[11px] tw-text-slate-400 tw-font-medium tw-block">Configure sales preferences</span>
                        </div>
                      </div>
                      <button
                        type="button"
                        id="accordion-toggle-sales"
                        onClick={() => this.state.status === 1 ? this.setState({ status: 0 }) : this.setState({ status: 1 })}
                        className={`tw-p-1.5 tw-rounded-lg tw-border tw-border-slate-200 tw-text-slate-450 tw-hover:text-slate-800 tw-hover:bg-slate-50 tw-transition-all tw-cursor-pointer ${this.state.status === 1 ? theme === "classic" ? 'tw-bg-[#4d4d4d] tw-text-white' : 'tw-bg-gradient-to-r tw-from-blue-600 tw-to-indigo-600 tw-text-white' : ''}`}
                      >
                        {this.state.status === 1 ? <Minus size={16} /> : <Plus size={16} />}
                      </button>
                    </div>
                  </div>

                  {/* Setting 7: e-Invoice Settings */}
                  {einvoice && <div id="setting-einvoice" className="tw-py-4">
                    <div className="tw-flex tw-items-center tw-justify-between tw-gap-4">
                      <div className="tw-flex tw-items-center tw-gap-3.5 tw-text-left">
                        <div className={`tw-w-10 tw-h-10 tw-rounded-xl ${theme === 'classic' ? 'tw-bg-[#f8f0e7] tw-text-[#4d4d4d]' : 'tw-bg-emerald-50 tw-text-emerald-600'} tw-flex tw-items-center tw-justify-center tw-shrink-0`}>
                          <FileCode size={18} />
                        </div>
                        <div>
                          <span className="tw-text-sm tw-font-extrabold tw-text-slate-800 tw-block">e-Invoice Settings</span>
                          <span className="tw-text-[11px] tw-text-slate-400 tw-font-medium tw-block">Configure e-invoice preferences</span>
                        </div>
                      </div>
                      <button
                        type="button"
                        id="accordion-toggle-einvoice"
                        onClick={() => this.state.status === 5 ? this.setState({ status: 0 }) : this.setState({ status: 5 })}
                        className={`tw-p-1.5 tw-rounded-lg tw-border tw-border-slate-200 tw-text-slate-450 tw-hover:text-slate-800 tw-hover:bg-slate-50 tw-transition-all tw-cursor-pointer ${this.state.status === 5 ? theme === "classic" ? 'tw-bg-[#4d4d4d] tw-text-white' : 'tw-bg-gradient-to-r tw-from-blue-600 tw-to-indigo-600 tw-text-white' : ''}`}
                      >
                        {this.state.status === 5 ? <Minus size={16} /> : <Plus size={16} />}
                      </button>
                    </div>
                  </div>}

                  {/* Setting 8: Purchase Settings */}
                  <div id="setting-purchase-settings" className="tw-py-4">
                    <div className="tw-flex tw-items-center tw-justify-between tw-gap-4">
                      <div className="tw-flex tw-items-center tw-gap-3.5 tw-text-left">
                        <div className={`tw-w-10 tw-h-10 tw-rounded-xl ${theme === 'classic' ? 'tw-bg-[#f8f0e7] tw-text-[#4d4d4d]' : 'tw-bg-emerald-50 tw-text-emerald-600'} tw-flex tw-items-center tw-justify-center tw-shrink-0`}>
                          <ShoppingBag size={18} />
                        </div>
                        <div>
                          <span className="tw-text-sm tw-font-extrabold tw-text-slate-800 tw-block">Purchase Settings</span>
                          <span className="tw-text-[11px] tw-text-slate-400 tw-font-medium tw-block">Configure purchase preferences</span>
                        </div>
                      </div>
                      <button
                        type="button"
                        id="accordion-toggle-purchase"
                        onClick={() => this.state.status === 4 ? this.setState({ status: 0 }) : this.setState({ status: 4 })}
                        className={`tw-p-1.5 tw-rounded-lg tw-border tw-border-slate-200 tw-text-slate-450 tw-hover:text-slate-800 tw-hover:bg-slate-50 tw-transition-all tw-cursor-pointer ${this.state.status === 4 ? theme === "classic" ? 'tw-bg-[#4d4d4d] tw-text-white' : 'tw-bg-gradient-to-r tw-from-blue-600 tw-to-indigo-600 tw-text-white' : ''}`}
                      >
                        {this.state.status === 4 ? <Minus size={16} /> : <Plus size={16} />}
                      </button>
                    </div>
                  </div>

                  {/* Setting 9: Mail Configuration */}
                  <div id="setting-mail-config" className="tw-py-4">
                    <div className="tw-flex tw-items-center tw-justify-between tw-gap-4">
                      <div className="tw-flex tw-items-center tw-gap-3.5 tw-text-left">
                        <div className={`tw-w-10 tw-h-10 tw-rounded-xl ${theme === 'classic' ? 'tw-bg-[#f8f0e7] tw-text-[#4d4d4d]' : 'tw-bg-purple-50 tw-text-purple-600'} tw-flex tw-items-center tw-justify-center tw-shrink-0`}>
                          <Mail size={18} />
                        </div>
                        <div>
                          <span className="tw-text-sm tw-font-extrabold tw-text-slate-800 tw-block">Mail Configuration</span>
                          <span className="tw-text-[11px] tw-text-slate-400 tw-font-medium tw-block">Configure mail server and templates</span>
                        </div>
                      </div>
                      <Link
                        to={"/mailsettings"}
                        className={`tw-p-1.5 tw-rounded-lg tw-border tw-border-slate-200 tw-text-slate-450 tw-hover:text-slate-800 tw-hover:bg-slate-50 tw-transition-all tw-cursor-pointer`}
                      >
                        <Link2 size={16} />
                      </Link>
                    </div>
                  </div>

                  {/* Setting 10: Templates Settings */}
                  <div id="setting-templates" className="tw-py-4">
                    <div className="tw-flex tw-items-center tw-justify-between tw-gap-4">
                      <div className="tw-flex tw-items-center tw-gap-3.5 tw-text-left">
                        <div className={`tw-w-10 tw-h-10 tw-rounded-xl ${theme === 'classic' ? 'tw-bg-[#f8f0e7] tw-text-[#4d4d4d]' : 'tw-bg-sky-50 tw-text-indigo-600'} tw-flex tw-items-center tw-justify-center tw-shrink-0`}  >
                          <LayoutTemplate size={18} />
                        </div>
                        <div>
                          <span className="tw-text-sm tw-font-extrabold tw-text-slate-800 tw-block">Templates Settings</span>
                          <span className="tw-text-[11px] tw-text-slate-400 tw-font-medium tw-block">Manage document templates</span>
                        </div>
                      </div>
                      <button
                        type="button"
                        id="accordion-toggle-templates"
                        onClick={() => this.state.status === 2 ? this.setState({ status: 0 }) : this.setState({ status: 2 })}
                        className={`tw-p-1.5 tw-rounded-lg tw-border tw-border-slate-200 tw-text-slate-450 tw-hover:text-slate-800 tw-hover:bg-slate-50 tw-transition-all tw-cursor-pointer ${this.state.status === 2 ? theme === "classic" ? 'tw-bg-[#4d4d4d] tw-text-white' : 'tw-bg-gradient-to-r tw-from-blue-600 tw-to-indigo-600 tw-text-white' : ''}`}
                      >
                        {this.state.status === 2 ? <Minus size={16} /> : <Plus size={16} />}
                      </button>
                    </div>
                  </div>
                  {/* Setting 11: Prefix and Serial No. Settings */}
                  <div id="setting-prefix" className="tw-py-4">
                    <div className="tw-flex tw-items-center tw-justify-between tw-gap-4">
                      <div className="tw-flex tw-items-center tw-gap-3.5 tw-text-left">
                        <div className={`tw-w-10 tw-h-10 tw-rounded-xl ${theme === 'classic' ? 'tw-bg-[#f8f0e7] tw-text-[#4d4d4d]' : 'tw-bg-rose-50 tw-text-rose-600'} tw-flex tw-items-center tw-justify-center tw-shrink-0`} >
                          <Settings2 size={18} />
                        </div>
                        <div>
                          <span className="tw-text-sm tw-font-extrabold tw-text-slate-800 tw-block">Prefix and Serial No. Settings</span>
                          <span className="tw-text-[11px] tw-text-slate-400 tw-font-medium tw-block">Configure prefixes and serial numbers</span>
                        </div>
                      </div>
                      <button
                        type="button"
                        id="accordion-toggle-prefix"
                        onClick={() => this.state.status === 3 ? this.setState({ status: 0 }) : this.setState({ status: 3 })}
                        className={`tw-p-1.5 tw-rounded-lg tw-border tw-border-slate-200 tw-text-slate-450 tw-hover:text-slate-800 tw-hover:bg-slate-50 tw-transition-all tw-cursor-pointer ${this.state.status === 3 ? theme === "classic" ? 'tw-bg-[#4d4d4d] tw-text-white' : 'tw-bg-gradient-to-r tw-from-blue-600 tw-to-indigo-600 tw-text-white' : ''}`}
                      >
                        {this.state.status === 3 ? <Minus size={16} /> : <Plus size={16} />}
                      </button>
                    </div>
                  </div>
                  {/* Setting 12: Logo Upload dropzone */}
                  <LogoUpdate />
                </div>

              </div>
              {this.state.status === 8 &&
                <div className="form-group col-md-7 p-3 mb-5 tw-bg-white tw-border tw-border-slate-200/60 tw-rounded-3xl tw-p-6 tw-shadow-sm tw-divide-y tw-divide-slate-100">
                  <MasterLedgerMapping />
                </div>}

              {this.state.status === 1 && (
                <div className="form-group col-md-7 p-3 mb-5 tw-bg-white tw-border tw-border-slate-200/60 tw-rounded-3xl tw-p-6 tw-shadow-sm tw-divide-y tw-divide-slate-100">
                  <Table className="table-sm m-0 p-0 table-bordred">
                    <TableBody>
                      <TableRow>
                        <TableCell className="text-md text-secondary p-3 font-weight-bold">
                          Sales Settings
                        </TableCell>
                        <TableCell></TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell className="text-md text-secondary p-3">
                          Auto JRE
                        </TableCell>
                        <TableCell align="right">
                          <OSSwitch checked={this.state.salesautojre} onChange={this.handleChangeSalesAutoJRE} />
                        </TableCell>
                      </TableRow>
                      {this.state.salesautojre ?
                        <TableRow>
                          <TableCell className="text-md text-secondary p-3">
                            Auto JRE Settings
                          </TableCell>
                          <TableCell align="right">
                            {/* <Link
                              to="/autojresettings"
                              className={`tw-p-1.5 tw-rounded-lg tw-border tw-border-slate-200 tw-text-slate-450 tw-hover:text-slate-800 tw-hover:bg-slate-50 tw-transition-all tw-cursor-pointer`}
                            >
                              <Link2 size={16} />
                            </Link> */}

                            <Link
                              type="button"
                              id="accordion-toggle-purchase"
                              to="/autojresettings"
                              className={`tw-p-1.5 tw-rounded-lg tw-border tw-border-slate-200 tw-text-slate-450 tw-hover:text-slate-800 tw-hover:bg-slate-50 tw-transition-all tw-cursor-pointer`}
                            >
                              <Link2 size={16} />
                            </Link>

                          </TableCell>
                        </TableRow>
                        : ""}
                      <TableRow>
                        <TableCell className="text-md text-secondary p-3">
                          Sale Order Price Editable
                        </TableCell>
                        <TableCell align="right">
                          <OSSwitch checked={this.state.soeditprice} onChange={this.handleChange} />
                        </TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell className="text-md text-secondary p-3">
                          Sale on Direct Price
                        </TableCell>
                        <TableCell align="right">
                          <OSSwitch checked={this.state.salescal} onChange={this.handleSalesCal} />
                        </TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell className="text-md text-secondary p-3">
                          Extra Markup
                        </TableCell>
                        <TableCell align="right">
                          <OSSwitch checked={this.state.allowextramakup} onChange={this.AllowExtraMarkup("salescal")} />
                        </TableCell>
                      </TableRow>
                      {/* <TableRow>
                            <TableCell className="text-md text-secondary p-3">
                              Value round off
                            </TableCell>
                            <TableCell>
                              <FormControlLabel
                                className="float-right my-0 mr-0"
                                control={
                                  <IOSSwitch
                                    className="sm my-0 mr-0"
                                    checked={this.state.salesroundoff}
                                    onChange={this.SalesValueRoundoff}
                                    name="checkedB"
                                  />
                                }
                              />
                            </TableCell>
                          </TableRow> */}
                      {/* <TableRow>
                            <TableCell className="text-md text-secondary p-3">
                              Delivery / Shipment Note
                            </TableCell>
                            <TableCell>
                              <FormControlLabel
                                className="float-right my-0 mr-0"
                                control={
                                  <IOSSwitch
                                    className="sm my-0 mr-0"
                                    checked={this.state.dnreq}
                                    onChange={this.handleDnReq}
                                    name="checkedB"
                                  />
                                }
                              />
                            </TableCell>
                          </TableRow> */}
                      <TableRow>
                        <TableCell className="text-md text-secondary p-3">
                          PO Upload Mandatory
                        </TableCell>
                        <TableCell align="right">
                          <OSSwitch checked={this.state.pouploadm} onChange={this.handlepouploadm} />
                        </TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell className="text-md text-secondary p-3">
                          Permit Invoicing for Past Dates
                        </TableCell>
                        <TableCell align="right">
                          <OSSwitch checked={this.state.backdateinvoicestatus} onChange={this.handlebackdateinvoice} />
                        </TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell className="text-md text-secondary p-3">
                          Products
                        </TableCell>
                        <TableCell align="right">
                          <OSSwitch checked={this.state.salesproducts} onChange={this.handleSalesCal} />
                        </TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell className="text-md text-secondary p-3">
                          Services
                        </TableCell>
                        <TableCell align="right">
                          <OSSwitch checked={this.state.salesservice} onChange={this.handleSalesService} />
                        </TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell className="text-md text-secondary p-3">
                          Products & Services
                        </TableCell>
                        <TableCell align="right">
                          <OSSwitch checked={this.state.salespands} onChange={this.handleSalesPandS} />
                        </TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell className="text-md text-secondary p-3">
                          License Numbers
                        </TableCell>
                        <TableCell align="right">
                          {/* <h4
                            className="fa fa-plus float-right cursorPointer"
                            onClick={this.handleLicense}
                          ></h4> */}
                          <button
                            type="button"
                            id="accordion-toggle-purchase"
                            onClick={this.handleLicense}
                            className={`tw-p-1.5 tw-rounded-lg tw-border tw-border-slate-200 tw-text-slate-450 tw-hover:text-slate-800 tw-hover:bg-slate-50 tw-transition-all tw-cursor-pointer ${this.state.status === 4 ? theme === "classic" ? 'tw-bg-[#4d4d4d] tw-text-white' : 'tw-bg-gradient-to-r tw-from-blue-600 tw-to-indigo-600 tw-text-white' : ''}`}
                          >
                            {this.state.status === 4 ? <Minus size={16} /> : <Plus size={16} />}
                          </button>
                        </TableCell>
                      </TableRow>
                      {this.state.licences.map((val, idx) => (
                        <TableRow key={idx}>
                          <TableCell>
                            <TextField
                              label="Name"
                              className="mr-3"
                              value={val.name}
                              onChange={(e) =>
                                this.onlicenceNameChange(
                                  e.target.value,
                                  idx
                                )
                              }
                              variant="standard"
                            ></TextField>
                            <TextField
                              label="License Number"
                              value={val.number}
                              onChange={(e) =>
                                this.onlicenceChange(e.target.value, idx)
                              }
                              variant="standard"
                            ></TextField>
                          </TableCell>
                          <TableCell>
                            <button
                              className="btn btn-sm hovbuttonColour mt-3 mr-1 fa fa-save"
                              onClick={() => this.updateLicence(val, idx)}
                              disabled={this.state.buttondisable}
                            ></button>
                            <button
                              className="btn btn-sm deletebutton mt-3 "
                              onClick={() => this.Deletelicence(val, idx)}
                              disabled={this.state.buttondisable}
                            >
                              <i className="fa fa-trash text-white"></i>
                            </button>
                          </TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                </div>
              )}

              {this.state.status === 4 && (
                <div className="form-group col-md-7 p-3 mb-5 tw-bg-white tw-border tw-border-slate-200/60 tw-rounded-3xl tw-p-6 tw-shadow-sm tw-divide-y tw-divide-slate-100">
                  <Table className="table-sm m-0 p-0 table-bordred">
                    <TableBody>
                      {/* <TableRow>
                            <TableCell className="text-md text-secondary p-3">
                              Invoice upload mandatory
                            </TableCell>
                            <TableCell>
                              <FormControlLabel
                                className="float-right my-0 mr-0"
                                control={
                                  <IOSSwitch
                                    className="sm my-0 mr-0"
                                    checked={this.state.invuploadm}
                                    onChange={this.handleinvuploadm}
                                    name="checkedB"
                                  />
                                }
                              />
                            </TableCell>
                          </TableRow> */}
                      <TableRow>
                        <TableCell className="text-md text-secondary p-3">
                          Products
                        </TableCell>
                        <TableCell align="right">
                          <OSSwitch checked={this.state.purchaseproducts} disabled />
                        </TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell className="text-md text-secondary p-3">
                          Services
                        </TableCell>
                        <TableCell align="right">
                          <OSSwitch checked={this.state.purchaseservice} onChange={this.handlePurchaseService} />
                        </TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell className="text-md text-secondary p-3">
                          Products & Services
                        </TableCell>
                        <TableCell align="right">
                          <OSSwitch checked={this.state.purchasepands} onChange={this.handlePurchasePandS} />
                        </TableCell>
                      </TableRow>
                      {/* <TableRow>
                            <TableCell className="text-md text-secondary p-3">
                              Value round off
                            </TableCell>
                            <TableCell>
                              <FormControlLabel
                                className="float-right my-0 mr-0"
                                control={
                                  <IOSSwitch
                                    className="sm my-0 mr-0"
                                    checked={this.state.purchaseroundoff}
                                    onChange={this.PurchaseValueRoundoff}
                                    name="checkedB"
                                  />
                                }
                              />
                            </TableCell>
                          </TableRow> */}

                      <TableRow>
                        <TableCell className="text-md text-secondary p-3">
                          Auto JRE
                        </TableCell>
                        <TableCell align="right">
                          <OSSwitch checked={this.state.purchaseautojre} onChange={this.handleChangePurchaseAutoJRE} />
                        </TableCell>
                        <>{this.state.purchaseautojre}</>
                      </TableRow>

                      {this.state.purchaseautojre ?
                        <TableRow>
                          <TableCell className="text-md text-secondary p-3">
                            Auto JRE Settings
                          </TableCell>
                          <TableCell align="right">

                            <Link
                              type="button"
                              id="accordion-toggle-purchase"
                              to="/purchaseautojresettings"
                              className={`tw-p-1.5 tw-rounded-lg tw-border tw-border-slate-200 tw-text-slate-450 tw-hover:text-slate-800 tw-hover:bg-slate-50 tw-transition-all tw-cursor-pointer`}
                            >
                              <Link2 size={16} />
                            </Link>

                          </TableCell>
                        </TableRow>
                        : ""}
                    </TableBody>
                  </Table>
                </div>
              )}

              {this.state.status === 2 && (
                <div className="form-group col-md-7 p-3 mb-5 tw-bg-white tw-border tw-border-slate-200/60 tw-rounded-3xl tw-p-6 tw-shadow-sm tw-divide-y tw-divide-slate-100">
                  <PdfTempletes />
                </div>
              )}

              {this.state.status === 3 && (
                <div className="form-group col-md-7 p-3 mb-5 tw-bg-white tw-border tw-border-slate-200/60 tw-rounded-3xl tw-p-6 tw-shadow-sm tw-divide-y tw-divide-slate-100">
                  <div className="card-header text-center text-md text-bold">
                    Prefix and Serial No. Settings
                  </div>
                  <div className="row p-2">
                    <div className="col-md-3">
                      <TextField
                        label="Customer Prefix"
                        value={this.state.customerprefix}
                        onChange={(e) =>
                          this.setState({ customerprefix: regexprefix.test(e.target.value) ? e.target.value : this.state.customerprefix })
                        }
                        disabled={this.state.customeredit === false}
                        size="small"
                        fullWidth
                      ></TextField>
                    </div>
                    <div className="col-md-3">
                      <TextField
                        label="Customer Serial No."
                        value={this.state.customersno}
                        onChange={(e) =>
                          this.setState({ customersno: regexslno.test(e.target.value) ? e.target.value : this.state.customersno })
                        }
                        disabled={this.state.customeredit === false}
                        size="small"
                        fullWidth
                      ></TextField>
                    </div>
                    <div className="col-md-3">
                      <TextField
                        label="Customer Id"
                        value={
                          this.state.customerprefix +
                          "-" +
                          this.state.customersno
                        }
                        disabled
                        size="small"
                        fullWidth
                      ></TextField>
                    </div>
                    {this.state.customeredit === true ? (
                      <div className="col-md-3 tw-flex tw-items-center">
                        <button
                          className="UI-btn UI-btn-primary fa fa-save"
                          onClick={this.updateCustprefix}
                        ></button>
                      </div>
                    ) : this.state.customereditstatus === "ACTIVE" ? (
                      ""
                    ) : (
                      <div className="col-md-3">
                        <button
                          className="UI-btn UI-btn-primary fa fa-edit"
                          onClick={this.handleCustomerEdit}
                        ></button>
                      </div>
                    )}
                  </div>

                  <div className="row p-2">
                    <div className="col-md-3">
                      <TextField
                        label="Supplier Prefix"
                        value={this.state.supplierprefix}
                        onChange={(e) =>
                          this.setState({ supplierprefix: regexprefix.test(e.target.value) ? e.target.value : this.state.supplierprefix })
                        }
                        disabled={this.state.supplieredit === false}
                        size="small"
                        fullWidth
                      ></TextField>
                    </div>
                    <div className="col-md-3">
                      <TextField
                        label="Supplier Serial No."
                        value={this.state.suppliersno}
                        onChange={(e) =>
                          this.setState({ suppliersno: e.target.value })
                        }
                        disabled={this.state.supplieredit === false}
                        size="small"
                        fullWidth
                      ></TextField>
                    </div>
                    <div className="col-md-3">
                      <TextField
                        label="Customer Id"
                        value={
                          this.state.supplierprefix +
                          "-" +
                          this.state.suppliersno
                        }
                        disabled
                        size="small"
                        fullWidth
                      ></TextField>
                    </div>
                    {this.state.supplieredit === true ? (
                      <div className="col-md-3">
                        <button
                          className="UI-btn UI-btn-primary fa fa-save"
                          onClick={this.updateSupplierPrefix}
                        ></button>
                      </div>
                    ) : this.state.suppliereditstatus === "ACTIVE" ? (
                      ""
                    ) : (
                      <div className="col-md-3">
                        <button
                          className="UI-btn UI-btn-primary fa fa-edit"
                          onClick={this.handleSupplierEdit}
                        ></button>
                      </div>
                    )}
                  </div>

                  <div className="row p-2">
                    <div className="col-md-3">
                      <TextField
                        label="Employee Prefix"
                        value={this.state.empprefix}
                        onChange={(e) =>
                          this.setState({ empprefix: regexprefix.test(e.target.value) ? e.target.value : this.state.empprefix })
                        }
                        disabled={this.state.empedit === false}
                        size="small"
                        fullWidth
                      ></TextField>
                    </div>
                    <div className="col-md-3">
                      <TextField
                        label="Employee Serial No."
                        value={this.state.empno}
                        onChange={(e) =>
                          this.setState({ empno: regexslno.test(e.target.value) ? e.target.value : this.state.empno })
                        }
                        disabled={this.state.empedit === false}
                        size="small"
                        fullWidth
                      ></TextField>
                    </div>
                    <div className="col-md-3">
                      <TextField
                        label="Employee Id"
                        value={
                          this.state.empprefix + this.state.empno
                        }
                        disabled
                        size="small"
                        fullWidth
                      ></TextField>
                    </div>
                    {this.state.empedit === true ? (
                      <div className="col-md-3">
                        <button
                          className="UI-btn UI-btn-primary fa fa-save"
                          onClick={this.updateEmployeePrefix}
                        ></button>
                      </div>
                    ) : this.state.empditstatus === "ACTIVE" ? (
                      ""
                    ) : (
                      <div className="col-md-3">
                        <button
                          className="UI-btn UI-btn-primary fa fa-edit"
                          onClick={this.handleEmployeeEdit}
                        ></button>
                      </div>
                    )}
                  </div>

                  <div className="row p-2">
                    <div className="col-md-3">
                      <TextField
                        label="Sale Order Prefix"
                        value={this.state.soprefix}
                        onChange={(e) =>
                          this.setState({ soprefix: regexprefix.test(e.target.value) ? e.target.value : this.state.soprefix })
                        }
                        disabled={this.state.soedit === false}
                        size="small"
                        fullWidth
                      ></TextField>
                    </div>
                    <div className="col-md-3">
                      <TextField
                        label="Sale Order Serial No."
                        value={this.state.sono}
                        onChange={(e) =>
                          this.setState({ sono: regexslno.test(e.target.value) ? e.target.value : this.state.sono })
                        }
                        disabled={this.state.soedit === false}
                        size="small"
                        fullWidth
                      ></TextField>
                    </div>
                    <div className="col-md-3">
                      <TextField
                        label="Sale Order Id"
                        value={this.state.soprefix + this.state.sono}
                        disabled
                        size="small"
                        fullWidth
                      ></TextField>
                    </div>
                    {this.state.soedit === true ? (
                      <div className="col-md-3">
                        <button
                          className="UI-btn UI-btn-primary fa fa-save"
                          onClick={this.updateSoprefix}
                        ></button>
                      </div>
                    ) : this.state.soeditstatus === "ACTIVE" ? (
                      ""
                    ) : (
                      <div className="col-md-3">
                        <button
                          className="UI-btn UI-btn-primary fa fa-edit"
                          onClick={this.handleSoEdit}
                        ></button>
                      </div>
                    )}
                  </div>

                  <div className="row p-2">
                    <div className="col-md-3">
                      <TextField
                        label="Purchase Order Prefix"
                        value={this.state.poprefix}
                        onChange={(e) =>
                          this.setState({ poprefix: regexprefix.test(e.target.value) ? e.target.value : this.state.poprefix })
                        }
                        disabled={this.state.poedit === false}
                        size="small"
                        fullWidth
                      ></TextField>
                    </div>
                    <div className="col-md-3">
                      <TextField
                        label="Purchase Order Serial No."
                        value={this.state.pono}
                        onChange={(e) =>
                          this.setState({ pono: regexslno.test(e.target.value) ? e.target.value : this.state.pono })
                        }
                        disabled={this.state.poedit === false}
                        size="small"
                        fullWidth
                      ></TextField>
                    </div>
                    <div className="col-md-3">
                      <TextField
                        label="Purchase Order Id"
                        value={prefix1 + "-" + this.state.poprefix + "-" + this.state.pono}
                        disabled
                        size="small"
                        fullWidth
                      ></TextField>
                    </div>
                    {this.state.poedit === true ? (
                      <div className="col-md-3">
                        <button
                          className="UI-btn UI-btn-primary fa fa-save"
                          onClick={this.updatePoprefix}
                        ></button>
                      </div>
                    ) : this.state.poeditstatus === "ACTIVE" ? (
                      ""
                    ) : (
                      <div className="col-md-3">
                        <button
                          className="UI-btn UI-btn-primary fa fa-edit"
                          onClick={this.handlePoEdit}
                        ></button>
                      </div>
                    )}
                  </div>

                  <div className="row p-2">
                    <div className="col-md-3">
                      <TextField
                        label="GRN Prefix"
                        value={this.state.grnprefix}
                        onChange={(e) =>
                          this.setState({ grnprefix: regexprefix.test(e.target.value) ? e.target.value : this.state.grnprefix })
                        }
                        disabled={this.state.grnedit === false}
                        size="small"
                        fullWidth
                      ></TextField>
                    </div>
                    <div className="col-md-3">
                      <TextField
                        label="GRN Serial No."
                        value={this.state.grnno}
                        onChange={(e) =>
                          this.setState({ grnno: regexslno.test(e.target.value) ? e.target.value : this.state.grnno })
                        }
                        disabled={this.state.grnedit === false}
                        size="small"
                        fullWidth
                      ></TextField>
                    </div>
                    <div className="col-md-3">
                      <TextField
                        label="GRN Id"
                        value={
                          prefix1 + "-" + this.state.grnprefix + "-" + this.state.grnno
                        }
                        disabled
                        size="small"
                        fullWidth
                      ></TextField>
                    </div>
                    {this.state.grnedit === true ? (
                      <div className="col-md-3">
                        <button
                          className="UI-btn UI-btn-primary fa fa-save"
                          onClick={this.updateGrnprefix}
                        ></button>
                      </div>
                    ) : this.state.grneditstatus === "ACTIVE" ? (
                      ""
                    ) : (
                      <div className="col-md-3">
                        <button
                          className="UI-btn UI-btn-primary fa fa-edit"
                          onClick={this.handleGrnEdit}
                        ></button>
                      </div>
                    )}
                  </div>

                  <div className="row p-2">
                    <div className="col-md-3">
                      <TextField
                        label="SCN Prefix"
                        value={this.state.scnprefix}
                        onChange={(e) =>
                          this.setState({ scnprefix: regexprefix.test(e.target.value) ? e.target.value : this.state.scnprefix })
                        }
                        disabled={this.state.scnedit === false}
                        size="small"
                        fullWidth
                      ></TextField>
                    </div>
                    <div className="col-md-3">
                      <TextField
                        label="SCN Serial No."
                        value={this.state.scnno}
                        onChange={(e) =>
                          this.setState({ scnno: regexslno.test(e.target.value) ? e.target.value : this.state.scnno })
                        }
                        disabled={this.state.scnedit === false}
                        size="small"
                        fullWidth
                      ></TextField>
                    </div>
                    <div className="col-md-3">
                      <TextField
                        label="SCN Id"
                        value={
                          prefix1 + "-" + this.state.scnprefix + "-" + this.state.scnno
                        }
                        fullWidth
                        disabled
                        size="small"
                      ></TextField>
                    </div>
                    {this.state.scnedit === true ? (
                      <div className="col-md-3">
                        <button
                          className="UI-btn UI-btn-primary fa fa-save"
                          onClick={this.updateSCNprefix}
                        ></button>
                      </div>
                    ) : this.state.scneditstatus === "ACTIVE" ? (
                      ""
                    ) : (
                      <div className="col-md-3">
                        <button
                          className="UI-btn UI-btn-primary fa fa-edit"
                          onClick={this.handleSCNedit}
                        ></button>
                      </div>
                    )}
                  </div>
                  <div className="row p-2">
                    <div className="col-md-3">
                      <TextField
                        label="Invoice Prefix"
                        value={this.state.invoiceprefix}
                        onChange={(e) =>
                          this.setState({ invoiceprefix: regexprefix.test(e.target.value) ? e.target.value : this.state.invoiceprefix })
                        }
                        disabled={this.state.invoiceedit === false}
                        size="small"
                        fullWidth
                      ></TextField>
                    </div>
                    <div className="col-md-3">
                      <TextField
                        label="Invoice Serial No."
                        value={this.state.invoicesno}
                        onChange={(e) =>
                          this.setState({ invoicesno: regexslno.test(e.target.value) ? e.target.value : this.state.invoicesno })
                        }
                        disabled={this.state.invoiceedit === false}
                        size="small"
                        fullWidth
                      ></TextField>
                    </div>
                    <div className="col-md-3">
                      <TextField
                        label="Invoice Id"
                        value={
                          prefix1 + "-" + this.state.invoiceprefix +
                          "-" +
                          this.state.invoicesno
                        }
                        fullWidth
                        disabled
                        size="small"
                      ></TextField>
                    </div>
                    {this.state.invoiceedit === true ? (
                      <div className="col-md-3">
                        <button
                          className="UI-btn UI-btn-primary fa fa-save"
                          onClick={this.updateInvprefix}
                        ></button>
                      </div>
                    ) : this.state.invoiceeditstatus === "ACTIVE" ? (
                      ""
                    ) : (
                      <div className="col-md-3">
                        <button
                          className="UI-btn UI-btn-primary fa fa-edit"
                          onClick={this.handleInvoiceEdit}
                        ></button>
                      </div>
                    )}
                  </div>

                  <div className="row p-2">
                    <div className="col-md-3">
                      <TextField
                        label="Delivery Note Prefix"
                        value={this.state.dnprefix}
                        onChange={(e) =>
                          this.setState({ dnprefix: regexprefix.test(e.target.value) ? e.target.value : this.state.dnprefix })
                        }
                        disabled={this.state.dnedit === false}
                        size="small"
                        fullWidth
                      ></TextField>
                    </div>
                    <div className="col-md-3">
                      <TextField
                        label="Delivery Note Serial No."
                        value={this.state.dnno}
                        onChange={(e) =>
                          this.setState({ dnno: regexslno.test(e.target.value) ? e.target.value : this.state.dnno })
                        }
                        disabled={this.state.dnedit === false}
                        size="small"
                        fullWidth
                      ></TextField>
                    </div>
                    <div className="col-md-3">
                      <TextField
                        label="Delivery Note Id"
                        value={prefix1 + "-" + this.state.dnprefix + "-" + this.state.dnno}
                        disabled
                        fullWidth
                        size="small"
                      ></TextField>
                    </div>
                    {this.state.dnedit === true ? (
                      <div className="col-md-3">
                        <button
                          className="UI-btn UI-btn-primary fa fa-save"
                          onClick={this.updateDnprefix}
                        ></button>
                      </div>
                    ) : this.state.dneditstatus === "ACTIVE" ? (
                      ""
                    ) : (
                      <div className="col-md-3">
                        <button
                          className="UI-btn UI-btn-primary fa fa-edit"
                          onClick={this.handleDNEdit}
                        ></button>
                      </div>
                    )}
                  </div>

                  <div className="row p-2">
                    <div className="col-md-3">
                      <TextField
                        label="Quotation Prefix"
                        value={this.state.qtprefix}
                        onChange={(e) =>
                          this.setState({ qtprefix: regexprefix.test(e.target.value) ? e.target.value : this.state.qtprefix })
                        }
                        disabled={this.state.qtedit === false}
                        size="small"
                        fullWidth
                      ></TextField>
                    </div>
                    <div className="col-md-3">
                      <TextField
                        label="Quotation Serial No."
                        value={this.state.qtno}
                        onChange={(e) =>
                          this.setState({ qtno: regexslno.test(e.target.value) ? e.target.value : this.state.qtno })
                        }
                        disabled={this.state.qtedit === false}
                        size="small"
                        fullWidth
                      ></TextField>
                    </div>
                    <div className="col-md-3">
                      <TextField
                        label="Quotation Id"
                        value={prefix1 + "-" + this.state.qtprefix + "-" + this.state.qtno}
                        disabled
                        fullWidth
                        size="small"
                      ></TextField>
                    </div>
                    {this.state.qtedit === true ? (
                      <div className="col-md-3">
                        <button
                          className="UI-btn UI-btn-primary fa fa-save"
                          onClick={this.updateQtprefix}
                        ></button>
                      </div>
                    ) : this.state.qteditstatus === "ACTIVE" ? (
                      ""
                    ) : (
                      <div className="col-md-3">
                        <button
                          className="UI-btn UI-btn-primary fa fa-edit"
                          onClick={this.handleQtEdit}
                        ></button>
                      </div>
                    )}
                  </div>

                  <div className="row p-2">
                    <div className="col-md-3">
                      <TextField
                        label="Asset Prefix"
                        value={this.state.assetprefix}
                        onChange={(e) =>
                          this.setState({ assetprefix: regexprefix.test(e.target.value) ? e.target.value : this.state.assetprefix })
                        }
                        disabled={this.state.assetedit === false}
                        size="small"
                        fullWidth
                      ></TextField>
                    </div>
                    <div className="col-md-3">
                      <TextField
                        label="Asset Serial No."
                        value={this.state.assetno}
                        onChange={(e) =>
                          this.setState({ assetno: regexslno.test(e.target.value) ? e.target.value : this.state.assetno })
                        }
                        disabled={this.state.assetedit === false}
                        size="small"
                        fullWidth
                      ></TextField>
                    </div>
                    <div className="col-md-3">
                      <TextField
                        label="Asset Id"
                        value={
                          prefix1 + "-" + this.state.assetprefix + "-" + this.state.assetno
                        }
                        disabled
                        size="small"
                        fullWidth
                      ></TextField>
                    </div>
                    {this.state.assetedit === true ? (
                      <div className="col-md-3">
                        <button
                          className="UI-btn UI-btn-primary fa fa-save"
                          onClick={this.updateAssetprefix}
                        ></button>
                      </div>
                    ) : this.state.asseteditstatus === "ACTIVE" ? (
                      ""
                    ) : (
                      <div className="col-md-3">
                        <button
                          className="UI-btn UI-btn-primary fa fa-edit"
                          onClick={this.handleAssetEdit}
                        ></button>
                      </div>
                    )}
                  </div>

                  <div className="row p-2">
                    <div className="col-md-3">
                      <TextField
                        label="Rental Prefix"
                        value={this.state.rentalprefix}
                        onChange={(e) =>
                          this.setState({ rentalprefix: regexprefix.test(e.target.value) ? e.target.value : this.state.rentalprefix })
                        }
                        disabled={this.state.rentaledit === false}
                        size="small"
                        fullWidth
                      ></TextField>
                    </div>
                    <div className="col-md-3">
                      <TextField
                        label="Rental Serial No."
                        value={this.state.rentalno}
                        onChange={(e) =>
                          this.setState({ rentalno: regexslno.test(e.target.value) ? e.target.value : this.state.rentalno })
                        }
                        disabled={this.state.rentaledit === false}
                        size="small"
                        fullWidth
                      ></TextField>
                    </div>
                    <div className="col-md-3">
                      <TextField
                        label="Rental Id"
                        value={prefix1 + "-" + this.state.rentalprefix + "-" + this.state.rentalno}
                        disabled
                        size="small"
                        fullWidth
                      ></TextField>
                    </div>
                    {this.state.rentaledit === true ? (
                      <div className="col-md-3">
                        <button
                          className="UI-btn UI-btn-primary fa fa-save"
                          onClick={this.updateRentalprefix}
                        ></button>
                      </div>
                    ) : this.state.rentaleditstatus === "ACTIVE" ? (
                      ""
                    ) : (
                      <div className="col-md-3">
                        <button
                          className="UI-btn UI-btn-primary fa fa-edit"
                          onClick={this.handleRentalEdit}
                        ></button>
                      </div>
                    )}
                  </div>

                  <div className="row p-2">
                    <div className="col-md-3">
                      <TextField
                        label="Sold Prefix"
                        value={this.state.soldprefix}
                        onChange={(e) =>
                          this.setState({ soldprefix: regexprefix.test(e.target.value) ? e.target.value : this.state.soldprefix })
                        }
                        disabled={this.state.soldedit === false}
                        size="small"
                        fullWidth
                      ></TextField>
                    </div>
                    <div className="col-md-3">
                      <TextField
                        label="Sold Serial No."
                        value={this.state.soldno}
                        onChange={(e) =>
                          this.setState({ soldno: regexslno.test(e.target.value) ? e.target.value : this.state.soldno })
                        }
                        disabled={this.state.soldedit === false}
                        size="small"
                        fullWidth
                      ></TextField>
                    </div>
                    <div className="col-md-3">
                      <TextField
                        label="Sold Id"
                        value={
                          prefix1 + "-" + this.state.soldprefix + "-" + this.state.soldno
                        }
                        disabled
                        size="small"
                        fullWidth
                      ></TextField>
                    </div>
                    {this.state.soldedit === true ? (
                      <div className="col-md-3">
                        <button
                          className="UI-btn UI-btn-primary fa fa-save"
                          onClick={this.updateSoldprefix}
                        ></button>
                      </div>
                    ) : this.state.soldeditstatus === "ACTIVE" ? (
                      ""
                    ) : (
                      <div className="col-md-3">
                        <button
                          className="UI-btn UI-btn-primary fa fa-edit"
                          onClick={this.handleSoldEdit}
                        ></button>
                      </div>
                    )}
                  </div>

                  <div className="row p-2">
                    <div className="col-md-3">
                      <TextField
                        label="Immediate production Prefix"
                        value={this.state.impprefix}
                        onChange={(e) =>
                          this.setState({ impprefix: regexprefix.test(e.target.value) ? e.target.value : this.state.impprefix })
                        }
                        disabled={this.state.impedit === false}
                        size="small"
                        fullWidth
                      ></TextField>
                    </div>
                    <div className="col-md-3">
                      <TextField
                        label="Immediate production Serial No."
                        value={this.state.impno}
                        onChange={(e) =>
                          this.setState({ impno: regexslno.test(e.target.value) ? e.target.value : this.state.impno })
                        }
                        disabled={this.state.impedit === false}
                        size="small"
                        fullWidth
                      ></TextField>
                    </div>
                    <div className="col-md-3">
                      <TextField
                        label="Immediate production Id"
                        value={
                          prefix1 + "-" + this.state.impprefix + "-" + this.state.impno
                        }
                        disabled
                        size="small"
                        fullWidth
                      ></TextField>
                    </div>
                    {this.state.impedit === true ? (
                      <div className="col-md-3">
                        <button
                          className="UI-btn UI-btn-primary fa fa-save"
                          onClick={this.updateImpprefix}
                        ></button>
                      </div>
                    ) : this.state.impeditstatus === "ACTIVE" ? (
                      ""
                    ) : (
                      <div className="col-md-3">
                        <button
                          className="UI-btn UI-btn-primary fa fa-edit"
                          onClick={this.handleImpEdit}
                        ></button>
                      </div>
                    )}
                  </div>

                  <div className="row p-2">
                    <div className="col-md-3">
                      <TextField
                        label="Estimation Prefix"
                        value={this.state.estprefix}
                        onChange={(e) =>
                          this.setState({ estprefix: regexprefix.test(e.target.value) ? e.target.value : this.state.estprefix })
                        }
                        disabled={this.state.estedit === false}
                        size="small"
                        fullWidth
                      ></TextField>
                    </div>
                    <div className="col-md-3">
                      <TextField
                        label="Estimation Serial No."
                        value={this.state.estno}
                        onChange={(e) =>
                          this.setState({ estno: regexslno.test(e.target.value) ? e.target.value : this.state.estno })
                        }
                        disabled={this.state.estedit === false}
                        size="small"
                        fullWidth
                      ></TextField>
                    </div>
                    <div className="col-md-3">
                      <TextField
                        label="Estimation Id"
                        value={
                          prefix1 + "-" + this.state.estprefix + "-" + this.state.estno
                        }
                        disabled
                        size="small"
                        fullWidth
                      ></TextField>
                    </div>
                    {this.state.estedit === true ? (
                      <div className="col-md-3">
                        <button
                          className="UI-btn UI-btn-primary fa fa-save"
                          onClick={this.updateEstprefix}
                        ></button>
                      </div>
                    ) : this.state.esteditstatus === "ACTIVE" ? (
                      ""
                    ) : (
                      <div className="col-md-3">
                        <button
                          className="UI-btn UI-btn-primary fa fa-edit"
                          onClick={this.handleEstEdit}
                        ></button>
                      </div>
                    )}
                  </div>

                  <div className="row p-2">
                    <div className="col-md-3">
                      <TextField
                        label="Joborder Prefix"
                        value={this.state.joprefix}
                        onChange={(e) =>
                          this.setState({ joprefix: regexprefix.test(e.target.value) ? e.target.value : this.state.joprefix })
                        }
                        disabled={this.state.joedit === false}
                        size="small"
                        fullWidth
                      ></TextField>
                    </div>
                    <div className="col-md-3">
                      <TextField
                        label="Joborder Serial No."
                        value={this.state.jono}
                        onChange={(e) =>
                          this.setState({ jono: regexslno.test(e.target.value) ? e.target.value : this.state.jono })
                        }
                        disabled={this.state.joedit === false}
                        size="small"
                        fullWidth
                      ></TextField>
                    </div>
                    <div className="col-md-3">
                      <TextField
                        label="jo Id"
                        value={prefix1 + "-" + this.state.joprefix + "-" + this.state.jono}
                        disabled
                        size="small"
                        fullWidth
                      ></TextField>
                    </div>
                    {this.state.joedit === true ? (
                      <div className="col-md-3">
                        <button
                          className="UI-btn UI-btn-primary fa fa-save"
                          onClick={this.updateJoprefix}
                        ></button>
                      </div>
                    ) : this.state.joeditstatus === "ACTIVE" ? (
                      ""
                    ) : (
                      <div className="col-md-3">
                        <button
                          className="UI-btn UI-btn-primary fa fa-edit"
                          onClick={this.handleJoEdit}
                        ></button>
                      </div>
                    )}
                  </div>

                  <div className="row p-2">
                    <div className="col-md-3">
                      <TextField
                        label="Store Prefix"
                        value={this.state.storeprefix}
                        onChange={(e) =>
                          this.setState({ storeprefix: regexprefix.test(e.target.value) ? e.target.value : this.state.storeprefix })
                        }
                        disabled={this.state.storeedit === false}
                        size="small"
                        fullWidth
                      ></TextField>
                    </div>
                    <div className="col-md-3">
                      <TextField
                        label="Store Serial No."
                        value={this.state.storeno}
                        onChange={(e) =>
                          this.setState({ storeno: regexslno.test(e.target.value) ? e.target.value : this.state.storeno })
                        }
                        disabled={this.state.storeedit === false}
                        size="small"
                        fullWidth
                      ></TextField>
                    </div>
                    <div className="col-md-3">
                      <TextField
                        label="store Id"
                        value={
                          prefix1 + "-" + this.state.storeprefix + "-" + this.state.storeno
                        }
                        disabled
                        size="small"
                        fullWidth
                      ></TextField>
                    </div>
                    {this.state.storeedit === true ? (
                      <div className="col-md-3">
                        <button
                          className="UI-btn UI-btn-primary fa fa-save"
                          onClick={this.updateStoreprefix}
                        ></button>
                      </div>
                    ) : this.state.storeeditstatus === "ACTIVE" ? (
                      ""
                    ) : (
                      <div className="col-md-3">
                        <button
                          className="UI-btn UI-btn-primary fa fa-edit"
                          onClick={this.handleStoreEdit}
                        ></button>
                      </div>
                    )}
                  </div>

                  <div className="row p-2">
                    <div className="col-md-3">
                      <TextField
                        label="Creditnote Prefix"
                        value={this.state.creditnoteprefix}
                        onChange={(e) =>
                          this.setState({
                            creditnoteprefix: regexprefix.test(e.target.value) ? e.target.value : this.state.creditnoteprefix
                          })
                        }
                        disabled={this.state.creditnoteedit === false}
                        size="small"
                        fullWidth
                      ></TextField>
                    </div>
                    <div className="col-md-3">
                      <TextField
                        label="Creditnote Serial No."
                        value={this.state.creditnoteno}
                        onChange={(e) =>
                          this.setState({ creditnoteno: regexslno.test(e.target.value) ? e.target.value : this.state.creditnoteno })
                        }
                        disabled={this.state.creditnoteedit === false}
                        size="small"
                        fullWidth
                      ></TextField>
                    </div>
                    <div className="col-md-3">
                      <TextField
                        label="Creditnote Id"
                        value={
                          prefix1 + "-" + this.state.creditnoteprefix + "-" + this.state.creditnoteno
                        }
                        disabled
                        size="small"
                        fullWidth
                      ></TextField>
                    </div>
                    {this.state.creditnoteedit === true ? (
                      <div className="col-md-3">
                        <button
                          className="UI-btn UI-btn-primary fa fa-save"
                          onClick={this.updatecreditnoteprefix}
                        ></button>
                      </div>
                    ) : this.state.creditnoteeditstatus === "ACTIVE" ? (
                      ""
                    ) : (
                      <div className="col-md-3">
                        <button
                          className="UI-btn UI-btn-primary fa fa-edit"
                          onClick={this.handlecreditnoteEdit}
                        ></button>
                      </div>
                    )}
                  </div>
                  {this.state.customprefixes.length > 0 &&
                    this.state.customprefixes.map((e, i) =>
                      <div className="row p-2">
                        <div className="col-md-3">
                          <TextField
                            label={`${e.type} Prefix`}
                            value={e.prefix}
                            onChange={(e) => {
                              let updatedata = this.state.customprefixes
                              updatedata[i] = {
                                ...updatedata[i], prefix: e.target.value
                              }
                              this.setState({ customprefixes: updatedata })
                            }
                            }
                            size="small"
                            disabled={e.edit === false}
                            fullWidth
                          ></TextField>
                        </div>
                        <div className="col-md-3">
                          <TextField
                            label={`${e.type} Serial No.`}
                            value={e.serialnum}
                            onChange={(e) => {
                              let updatedata = this.state.customprefixes
                              updatedata[i] = {
                                ...updatedata[i], serialnum: e.target.value
                              }
                              this.setState({ customprefixes: updatedata })
                            }
                            }
                            size="small"
                            disabled={e.edit === false}
                            fullWidth
                          ></TextField>
                        </div>
                        <div className="col-md-3">
                          <TextField
                            label={`${e.type} Id`}
                            value={
                              prefix1 + "-" + e.prefix + "-" + e.serialnum
                            }
                            size="small"
                            disabled
                            fullWidth
                          ></TextField>
                        </div>
                        {e.edit ? (
                          <div className="col-md-3">
                            <button
                              className="UI-btn UI-btn-primary fa fa-save"
                              onClick={() => this.updatecustomprefix(e, i)}
                            ></button>
                          </div>
                        ) : e.activestatus === "ACTIVE" ? (
                          ""
                        ) : (
                          <div className="col-md-1">
                            <button
                              className="UI-btn UI-btn-primary fa fa-edit"
                              onClick={() => {
                                let updatedata = this.state.customprefixes
                                updatedata[i] = {
                                  ...updatedata[i], edit: true
                                }
                                this.setState({ customprefixes: updatedata })
                              }}
                            ></button>
                          </div>
                        )}
                      </div>)}

                </div>
              )}

              {this.state.status === 5 && (
                <div className="form-group col-md-7 p-3 mb-5 tw-bg-white tw-border tw-border-slate-200/60 tw-rounded-3xl tw-p-6 tw-shadow-sm tw-divide-y tw-divide-slate-100">
                  <Einvoicesettings />
                </div>
              )}
            </div>
          </div>
        </Layout>
      </div>
    );
  }
}
export default withRouter(Settings);